<template>
  <div class="doc panel">
    <div v-show="!edit_mode" class="view">
      <a class="icon" :class="type" :href="doc.url" target="_blank"></a>
      <img class="go" src="~@/assets/icons/go.svg" />
      <div class="text">
        <div class="top">
          <h4>{{ doc.title }}</h4>
          <span>{{ date }}</span>
        </div>
        <div class="bottom">
          <p>{{ doc.description || 'Add a description' }}</p>
          <a :href="doc.url" target="_blank">Click to open</a>
        </div>
      </div>

      <div class="actions">
        <img src="~@/assets/icons/edit.svg" @click="toggleMode()" />
        <img src="~@/assets/icons/trash_only.svg" @click="deleteDoc(doc)" />
      </div>
    </div>

    <div v-if="edit_mode" class="edit">
      <document-form
        :document="doc"
        :onSave="save"
        :onClose="toggleMode"
        :onChange="onChange"
      />
    </div>
  </div>
</template>

<script>
import DocumentForm from './DocumentForm';
import moment from 'moment';

export default {
  name: 'DocumentCard',
  data() {
    return {
      edit_mode: false,
    };
  },
  props: {
    doc: Object,
    onChange: Function,
  },
  methods: {
    toggleMode() {
      this.edit_mode = !this.edit_mode;
    },
    save(doc) {
      const new_doc = Object.assign({}, doc);
      new_doc.updatedAt = moment().toISOString();
      this.$store.dispatch('setDocForEdit', new_doc);
      this.edit_mode = false;

      if (this.onChange) {
        this.onChange();
      }
    },
    deleteDoc(doc) {
      this.$store.dispatch('deleteDocForEdit', doc);

      if (this.onChange) {
        this.onChange();
      }
    },
  },
  computed: {
    type() {
      if (!this.doc || !this.doc.type) return '';
      return this.doc.type.toLowerCase();
    },
    date() {
      if (!this.doc || !this.doc.updatedAt) return '';
      return moment(this.doc.updatedAt).format('DD MMM YYYY, h:mma');
    },
  },
  components: {
    'document-form': DocumentForm,
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/_styles.scss';

.doc.panel {
  margin-bottom: 12px;
  padding: 16px 18px;
  transition: all 0.4s;
  position: relative;

  > .view {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: nowrap;
  }

  &:hover {
    box-shadow: 0 0 14px 2px rgba(41, 42, 44, 0.09);

    .text .bottom {
      p {
        display: none;
      }

      a {
        display: inline-block;
      }
    }

    .go {
      opacity: 1;
    }

    .actions {
      display: block;
    }
  }

  .icon {
    width: 48px;
    height: 48px;
    background-repeat: no-repeat;
    background-size: 336px 96px;
    background-image: url(~@/assets/icons/documents.svg);
    background-position: top left -240px;
    margin-right: 10px;

    &.pdf {
      background-position: top -48px left -0px;
    }

    &.word {
      background-position: top -48px left -48px;
    }

    &.excel {
      background-position: top -48px left -96px;
    }

    &.image,
    &.img {
      background-position: top -48px left -144px;
    }

    &.powerpoint {
      background-position: top -48px left -288px;
    }

    &.zip {
      background-position: top -48px left -192px;
    }
  }

  .go {
    position: absolute;
    top: 50px;
    left: 49px;
    z-index: 1;
    opacity: 0;
    pointer-events: none;
  }

  .text {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
    max-width: 480px;

    .top {
      min-width: 100%;

      h4 {
        display: inline-block;
        margin: 0;
        font-size: 14px;
        font-weight: 500;
        color: #26292f;
        margin-right: 10px;
        text-overflow: ellipsis;
        overflow: hidden;
        max-width: 330px;
        white-space: nowrap;
        position: relative;
        top: 3px;
      }

      span {
        font-size: 13px;
        font-weight: 400;
        color: #acb6c1;
      }
    }

    .bottom {
      p,
      a {
        font-size: 14px;
        font-weight: 400;
        color: #26292f;
        margin: 0;
        display: inline-block;
        text-overflow: ellipsis;
        overflow: hidden;
        max-width: 480px;
        white-space: nowrap;
        position: relative;
        top: 2px;
      }

      a {
        display: none;
        color: #acb6c1;
        text-decoration: underline;
        cursor: pointer;
      }
    }
  }

  .actions {
    position: absolute;
    right: 25px;
    top: 18px;
    display: none;

    img {
      cursor: pointer;
      margin-left: 15px;

      &:first-child {
        margin-left: 0px;
      }
    }
  }
}
</style>
